<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.125.125h19.75v19.75H.125V.125z" />
    <path
      d="M14.57 1.771H3.602A1.827 1.827 0 001.773 3.6v12.8c0 1.006.814 1.829 1.828 1.829h12.8a1.833 1.833 0 001.83-1.829V5.428L14.573 1.77h-.003zM10 16.401c-1.518 0-2.742-1.225-2.742-2.743S8.482 10.914 10 10.914s2.742 1.226 2.742 2.744S11.518 16.4 10 16.4zm2.742-9.143H3.6V3.6h9.142v3.658z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
